import tinycolor from 'tinycolor2'

export const isLight = (color: string) => tinycolor(color).getLuminance() > 0.85

export const getColorFromText = (text: string) => {
  const getHash = (text: string) => {
    return text
      .split('')
      .reduce((previous, current) => Math.abs(Math.sin(current.charCodeAt(0) + previous) * 360), 0)
  }

  return `hsl(${[getHash(text), '40%', '50%'].join()})`
}
